import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  SubTitleExtraSmall,
  FormLabelSmall,
  ButtonTextMedium,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Avatar} from '@spaced-out/ui-design-system/lib/components/Avatar';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  toastApi,
  TOAST_SEMANTIC,
  Toast,
  ToastTitle,
} from '@spaced-out/ui-design-system/lib/components/Toast';

import {classify} from 'src/utils/classify';
import {useDispatch, useSelector} from 'react-redux';
import {selectUserInfo} from 'src/selectors/crm';

import * as reduxApi from 'src/utils/redux-api-v2';

import css from './approve-offer-tabs.css';


export const ApprovalStatus = ({
  // @ts-expect-error - TS7031 - Binding element 'approvalObject' implicitly has an 'any' type.
  approvalObject,
  // @ts-expect-error - TS7031 - Binding element 'approverStatusesList' implicitly has an 'any' type.
  approverStatusesList,
  // @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type.
  type,
  viewOnly = false,
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const {user: userInfo} = useSelector(selectUserInfo) ?? {};
  const dispatch = useDispatch();
  const [sendingReminder, setSendingReminder] = React.useState(false);

  const handleSendReminderForApproval = async (approver: any) => {
    setSendingReminder(true);
    await dispatch(
      reduxApi.post(
        `api/resend-offer-letter-approval?offerApproverStatusId=${approver.offerApproverStatusId}&approverId=${approver.userId}`,
        undefined,
        {},
        {
          apiPath: '/trmapi/',
        },
      ),
    )
      .then(() =>
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>
              {t('Reminder_sent_successfully', 'Reminder sent successfully')}
            </ToastTitle>
          </Toast>,
        ),
      )
      .catch(() =>
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {t('Send_Reminder_Failed', 'Send Reminder Failed')}
            </ToastTitle>
          </Toast>,
        ),
      )
      .finally(() => {
        setSendingReminder(false);
      });
  };

  return (
    <div className={css.tabContainer}>
      {approvalObject?.approvalChain.steps.map((step: any, index: any) => {
        // @ts-expect-error - TS7006 - Parameter 'approver' implicitly has an 'any' type.
        step.approvers.forEach((approver) => {
          const approverStatus = approverStatusesList
            ? approverStatusesList.find(
                // @ts-expect-error - TS7006 - Parameter 'approverStatus' implicitly has an 'any' type.
                (approverStatus) =>
                  approverStatus.approverId === approver.userId &&
                  approverStatus.active,
              )
            : null;
          approver['status'] = approverStatus
            ? approverStatus.status
            : 'NOT_STARTED';
          approver['comment'] = approverStatus ? approverStatus.comment : '-';
          approver[
            type === 'JOB' ? 'jobApproverStatusId' : 'offerApproverStatusId'
          ] = approverStatus && approverStatus.id;
          approver.updatedOn = approverStatus ? approverStatus.updatedOn : null;
          approver.createdOn = approverStatus ? approverStatus.createdOn : null;
        });

        return (
          <div className={css.step}>
            <div className={css.stepHeader}>
              <SubTitleExtraSmall
                color={
                  step.approvers.some(
                    // @ts-expect-error - TS7006 - Parameter 'approver' implicitly has an 'any' type.
                    (approver) => approver.status === 'NOT_STARTED',
                  ) && !viewOnly
                    ? 'disabled'
                    : 'primary'
                }
              >
                {t('Step', 'Step')} #{index + 1}
              </SubTitleExtraSmall>
              <div className={css.conditonCont}>
                <Icon
                  name={step.approvalCondition === 'ONE' ? 'user' : 'users'}
                  size="small"
                  color={
                    step.approvers.some(
                      // @ts-expect-error - TS7006 - Parameter 'approver' implicitly has an 'any' type.
                      (approver) => approver.status === 'NOT_STARTED',
                    ) && !viewOnly
                      ? 'disabled'
                      : 'primary'
                  }
                />
                <FormLabelSmall
                  color={
                    step.approvers.some(
                      // @ts-expect-error - TS7006 - Parameter 'approver' implicitly has an 'any' type.
                      (approver) => approver.status === 'NOT_STARTED',
                    ) && !viewOnly
                      ? 'disabled'
                      : 'primary'
                  }
                >
                  {step.approvalCondition === 'ONE'
                    ? t('One_need_to_approve', 'One need to approve')
                    : t('All_need_to_approve', 'All need to approve')}
                </FormLabelSmall>
              </div>
            </div>
            <div
              className={classify(css.approvers, {
                [css.approversWithStatus]: approverStatusesList.length > 0,
              })}
            >
              {/* @ts-expect-error - TS7006 - Parameter 'approver' implicitly has an 'any' type. */}
              {step.approvers.map((approver) => {
                const approverStatus = approver.status ?? '';

                return (
                  <div
                    className={classify(css.agentAvatarAndInfoContainer, {
                      [css.agentAvatarAndInfoContainerWithStatus]:
                        approverStatusesList.length > 0,
                    })}
                  >
                    <div className={css.agentLeftSlot}>
                      <Avatar
                        color={
                          approver.status === 'NOT_STARTED' && !viewOnly
                            ? 'indigo'
                            : 'gray'
                        }
                        size="small"
                        text={approver.user?.fullName}
                        classNames={
                          approver.status === 'NOT_STARTED' && !viewOnly
                            ? {text: css.disabledAvatar}
                            : {}
                        }
                      />
                      <ButtonTextMedium
                        color={
                          approver.status === 'NOT_STARTED' && !viewOnly
                            ? 'disabled'
                            : 'primary'
                        }
                      >
                        {approver.user?.fullName}
                      </ButtonTextMedium>
                    </div>

                    <div className={css.statusContainer}>
                      {/* isPublicLink check to be added too - Arush */}
                      {approverStatus === 'PENDING' &&
                        approver.user.id !== userInfo.id && (
                          <Tooltip
                            title={t('Send_Reminder', 'Send Reminder')}
                            elevation="modal"
                          >
                            <Button
                              iconLeftName="bell"
                              size="small"
                              type="secondary"
                              onClick={() =>
                                handleSendReminderForApproval(approver)
                              }
                              isLoading={sendingReminder}
                            />
                          </Tooltip>
                        )}

                      {approverStatus === 'PENDING' ? (
                        <Tooltip
                          title={t('Approval_Pending', 'Approval Pending')}
                          elevation="modal"
                        >
                          <Icon name="exclamation-circle" color="warning" />
                        </Tooltip>
                      ) : approverStatus === 'APPROVED' ? (
                        <Tooltip
                          title={t('Approved', 'Approved')}
                          elevation="modal"
                        >
                          <Icon color="success" name="check-circle" />
                        </Tooltip>
                      ) : approverStatus === 'NOT_REQUIRED' ? (
                        <Tooltip
                          title={t(
                            'Approval_Not_Required',
                            'Approval Not Required',
                          )}
                          elevation="modal"
                        >
                          <Icon name="exclamation-circle" color="warning" />
                        </Tooltip>
                      ) : approverStatus === 'REJECTED' ? (
                        <Tooltip
                          title={t('Rejected', 'Rejected')}
                          elevation="modal"
                        >
                          <Icon color="danger" name="exclamation-circle" />
                        </Tooltip>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
